// app/components/CrewUnreadDot.tsx
// Dot indicator for crew chat unread state. Grey when unread, gold when mentioned.
// Does NOT apply to employer DMs (those keep numeric unread counts).

export function CrewUnreadDot({
  hasUnread,
  hasMention,
  className = "",
}: {
  hasUnread: boolean;
  hasMention: boolean;
  className?: string;
}) {
  if (!hasUnread && !hasMention) return null;
  const colour = hasMention ? "bg-gold" : "bg-text-muted";
  const label = hasMention ? "New mention" : "New messages";
  return (
    <span
      role="status"
      aria-label={label}
      className={`inline-block w-1.5 h-1.5 rounded-full ${colour} ${className}`}
    />
  );
}
